export const getClusterConfig = ({ tagGroupId }) => ({
    url: '/api/clusters',
    method: 'GET',
    params: {
        tag_group: tagGroupId,
    },
});

export const editClusterConfig = ({
    id,
    name,
    statusBudgetManager,
    statusBidManager,
    monthlyBudget,
    tagGroup,
    changeType,
}) => ({
    url: `/api/clusters/${id}`,
    method: 'PATCH',
    data: {
        id,
        name,
        status_budget_manager: statusBudgetManager,
        status_bid_manager: statusBidManager,
        monthly_budget: monthlyBudget,
        tag_group: tagGroup,
        change_type: changeType,
    },
});
